import Upscori_form from "./upscoriform";
import styles from "./upscori.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Image from "next/image";
//import Upscoribanner from "../../assets/images/upsc/Civil-Service-Orientation-Web-Banner.webp";
//import MobUpscoribanner from "../../assets/images/upsc/Civil-Service-Orientation-mobile-Banner.webp";
import Head from "next/head";

export default function index() {
  const prelimlist =[
    {list:"The programme aims to educate the aspirants about various aspects of cracking the civil services examination"},
    {list:"This session includes a discussion of the civil service profile, examination awareness, and preparation tips."},
    {list:"Session will be conducted on every saturday at 6 pm @ Door No 18, Old plot No 109, New plot No 259, AL Block, 4th Avenue, Shanthi Colony, Anna Nagar, Chennai-600040."},
    
  ]
  return (
    <>
    <Head>
   
                <meta charset="UTF-8" />
                
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="noindex,nofollow" />
                <meta name="robots" content="noindex, nofollow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2026-01-06T05:43:44+00:00" />
                <title>Decoding UPSC Exam Orientation: Expert Strategies and Tips</title>
                <meta name="title" content="Decoding UPSC Exam Orientation: Expert Strategies and Tips" />
                <meta name="description" content="Discover effective strategies with UPSC Exam Orientation. Gain insights, tips, and guidance for mastering the exam. Start your journey to success today!" />
                <link rel="canonical" href="https://www.shankariasacademy.com/upsc-orientation-program/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="UPSC orientation program 2026 | Shankar IAS Academy" />
                <meta property="og:description" content="Discover effective strategies with UPSC Exam Orientation. Gain insights, tips, and guidance for mastering the exam. Start your journey to success today!" />
                <meta property="og:url" content="https://www.shankariasacademy.com/upsc-orientation-program/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
    </Head>
    <Navbar />
    {/*<div className="container">
        <div className="row d-none d-md-block">
            <div className="col mb-3">
              <Image
                src={Upscoribanner}
                alt="orientation banner"
                title="UPSC orientation Test Series 2024"
                className="img-fluid w-100"
              />
            </div>
          </div>

          <div className="row d-block d-md-none">
          <div className="col mb-3">
              <Image
                src={MobUpscoribanner}
                alt="orientation banner"
                title="UPSC orientation"
                className="img-fluid w-100"
              />
            </div>
          </div>
      </div> /*/}
    {/* <Upscori_form /> */}
    <div className="container mt-5">
      <h2 className={`${styles.sectiontitle} mb-md-0`}>Shankar IAS Academy offers a free orientation program for the UPSC Aspirants.</h2>
      <ul className={`${styles.ulclass} ps-1 pt-2`}>
                            {prelimlist.map((item,index)=>(
                                  <li
                                    className={`${styles.ulliclass} ${styles.acheiverrank}`}
                                    id={styles.acheiverrankspecial} key={index}
                                  >
                                    <div className="d-inline">
                                      <p className={`${styles.ullispan} d-inline`}>
                                        {item.list}
                                      </p>
                                    </div>
                                  </li>
                              ))}
                            </ul>
    </div>
    <Footer />
    </>
  )
}
